// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#users .v-select.v-text-field--outlined:not(.v-text-field--single-line) .v-select__selections[data-v-cc2581c4] {\n    height: 30px !important;\n    overflow-y: hidden !important;\n    overflow-x: hidden !important;\n}\n", ""]);
// Exports
module.exports = exports;
